<template>
  <div class="page noselect">

    <!--        <div class="absBack" style="top: 137px;">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->


    <!--        <cat-slider-->
    <!--                @selectCat="gotoCat"></cat-slider>-->
    <!--        <div style="height: 70px"></div>-->

    <!--        <div class="spacer-40"></div>-->

    <!--        <h1 class="text-center">Korb</h1>-->

    <div class="tablet pt-10"></div>

    <div class="text-center" v-if="$store.state.enableOrderModeSelection">
      <div class="invisible all">{{ displayOrderModeSelection }}</div>
      <div class="pt-4 pb-4" v-if="showOrderModeSwitcher">
        <OrderModeSwitcher></OrderModeSwitcher>
      </div>
      <!--      <div class="mobile pa-3 pt-7">-->
      <!--        <OrderModeSwitcher-->
      <!--          >-->
      <!--        </OrderModeSwitcher>-->
      <!--      </div>-->
      <!--      <div class="tablet pl-2 pr-2 pt-7 pb-4">-->
      <!--        <OrderModeSwitcher-->
      <!--          >-->
      <!--        </OrderModeSwitcher>-->
      <!--      </div>-->

      <!--      <v-container grid-list-lg>-->
      <!--        -->
      <!--      </v-container>-->

    </div>


    <!--        <div class="indented">-->
    <v-container class="bgw myBorderRadius kioskBorder pt-2 mt-3">
      <div v-if="cartItems.length === 0" class="text-center mt-5">
        <div class="spacer-25"></div>
        <h3 class="">Dein Korb ist aktuell leer</h3>
        <div class="spacer-25"></div>
        <div class="text-center">
          <v-btn class="btn-df" rounded @click.native.passive="$ebus.$emit('goto',{name:'Sortiment'})">
            Zum Sortiment
          </v-btn>
        </div>
      </div>

      <!--            <p>Ab einem Bestellwert von 30 Euro erhälst Du ein hochwertiges Öl-->
      <!--                in der kleinen Geschenk- oder Sprühflasche gratis dazu 🎁. Hier findest du Beispiele an-->
      <!--                <router-link :to="{ name: 'Geschenkverpackung' }">Geschenkverpackungen</router-link>-->
      <!--                .-->
      <!--            </p>-->

      <div class="pmRow" v-if="cartItems.length > 0">
        <!--&lt;!&ndash;                DEBUG cartItems&ndash;&gt;-->
        <!--                <div v-for="ci in $store.getters.cartItems" class="pb-6" style="word-break: break-word;">-->
        <!--                    {{JSON.stringify(ci)}}-->
        <!--                </div>-->

        <table class="theader maxw">
          <tr class="boldHead">
            <td class="text-left" style="width: auto">
              Artikel im Korb
            </td>
            <td style="width: 154px" class="text-center">
              <div class="anzahl" style="width: 154px">Anzahl<span class="hidden-sm-and-up">/Preis</span>
              </div>
            </td>
            <td style="width: 90px" class="text-center hidden-xs-only">Preis</td>
          </tr>
        </table>
      </div>

      <div class="itemRow pmRow" v-for="item in cartItems">

        <table class="maxw items pointer table-collapse" v-if="item.isCoupon"
               @click.passive.stop="showCouponInfo(item)">
          <tr>
            <td class="b text-left">
              <div style="">
                <div>
                  <!--                                <div style="font-size: 1.3em;">-->
                  {{ item.nameToDisplay | noHtml }}
                  <!--                                    <span v-if="item.description"> | {{item.description}}</span>-->
                </div>
                <div v-if="item.text" class="displayExtras">
                  {{ item.text | noHtml }}
                </div>
              </div>
            </td>
            <td class="c counterStuff">
              <v-row>
                <v-col>
                  <div class="d-flex justify-end align-center maxh" style="opacity: 0">
                    <img class="minusImg pointer invertImg"
                         src="../assets/icons/item-minus.png">
                    <div>0</div>
                    <img class="plusImg pointer invertImg"
                         src="../assets/icons/item-plus.png">
                  </div>
                </v-col>
                <v-col>
                  <div class="d-flex justify-end align-center maxh">
                    <div class="text-no-wrap" v-if="item.type==='bundle'">{{ item.amount | priceTotal }}
                    </div>
                    <div class="text-no-wrap" v-if="item.type==='amount'">-{{ item.amount | priceTotal }}
                    </div>
                    <div class="text-no-wrap" v-if="item.type==='discount'">-{{ item.discount }}%
                    </div>
                    <v-icon medium @click.native.passive.stop="deleteCartItem(item)"
                            class="ml-2 myBlack pointer">mdi-delete-forever
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
            </td>
          </tr>
        </table>
        <table class="maxw items" v-else>
          <tr>
            <td class="b text-left">
              <div style="; cursor: pointer" class="pointer" @click="gotoItem(item)">
                <div>
                  <!--                                <div style="font-size: 1.2em;">-->
                  <span>
                                        <div v-if="item.gang" class="gang">{{ item.gang | uppercase }}: </div>
                                    </span>
                  <span v-if="item.isOffer"><span
                    v-if="item.usecase ==='takeAway'">Abholer-Angebot</span><span
                    v-else>Angebot</span>: </span>
                  <!--                                    Verfügbargeit-->
                  <!--                                    <v-icon class="mr-2 hidden-xs-only"-->
                  <!--                                            :color="itemAvailable(item) === true ? 'green' : 'red'" small>mdi-circle-->
                  <!--                                    </v-icon>-->
                  {{ item.nameToDisplay }} {{ displayItemVol(item) }}
                  <!--                                    <span v-if="item.description"> | {{item.description}}</span>-->
                </div>
                <div v-if="item.extras.length > 0" class="displayExtras">
                  {{ item.extras | extrasList(true) }}
                </div>
              </div>
              <div @click.passive="editNotes(item)" class="displayExtras pointer"
                   v-if="$store.state.enableItemNote">
                <div class="d-inline-block">Anmerkung</div>
                <div class="d-inline-block notes" v-if="item.notes.length > 0">:&nbsp;{{ item.notes }}
                </div>
                <div class="d-inline-block">
                  &nbsp;<v-icon class="myBlack">mdi-pencil</v-icon>
                </div>
              </div>
              <div v-else class="pt-3"></div>
            </td>
            <td class="c counterStuff">
              <v-row>
                <v-col>
                  <div class="d-flex align-center maxh" :class="{'justify-end': !item.unikat}">
                    <img class="minusImg pointer invertImg" v-if="!item.unikat"
                         @click.passive="decrementCartItem(item)"
                         src="../assets/icons/item-minus.png">
                    <div>{{ item.count }}</div>
                    <img class="plusImg pointer invertImg" v-if="!item.unikat"
                         @click.passive="incrementCartItem(item)"
                         src="../assets/icons/item-plus.png">
                  </div>
                </v-col>
                <v-col>
                  <div class="d-flex justify-end align-center maxh">
                    <div class="d-flex d-sm-block">
                      <div v-if="item.originalItemTotal" class="text-decoration-line-through">
                        {{ item.originalItemTotal | priceTotal }}
                      </div>
                      <div class="pl-3 hidden-sm-and-up"></div>
                      <div class="text-no-wrap">{{ item.itemTotal | priceTotal }}</div>
                    </div>
                    <v-icon medium @click.native.passive="deleteCartItem(item)"
                            class="ml-2 myBlack pointer" medium>mdi-delete-forever
                    </v-icon>
                  </div>
                </v-col>
              </v-row>

              <!--                            <img src="../assets/icons/item-minus.png">-->
            </td>
            <!--                        <td class="counter">{{item.count}}</td>-->
            <!--                        <td class="d counterStuff" @click.passive="incrementCartItem(item)">-->
            <!--                            <img src="../assets/icons/item-plus.png">-->
            <!--                            &lt;!&ndash;                        <v-btn fab dark small color="#617a94">&ndash;&gt;-->
            <!--                            &lt;!&ndash;                            <v-icon dark>add</v-icon>&ndash;&gt;-->
            <!--                            &lt;!&ndash;                        </v-btn>&ndash;&gt;-->
            <!--                        </td>-->
            <!--                        <td class="e text-center">{{item.itemTotal | price}}</td>-->
            <!--                        <td class="f textRight" @click.passive="deleteCartItem(item)">-->
            <!--                            <v-icon medium>mdi-delete-forever</v-icon>-->
            <!--                        </td>-->
          </tr>
        </table>
      </div>

      <div class="indented mt-0">
        <div class="text-right flex-grow-1">
          <div class="d-inline-block">
            <table class="mySumTable">
              <tr v-if="totalSavedByDiscounts>0">
                <td>Zwischensumme</td>
                <td>{{ $store.getters.cartSum | priceTotal }}</td>
              </tr>
              <tr v-if="totalSavedByDiscounts>0" class="rabattColor">
                <td>Rabattsumme:</td>
                <td>- {{ totalSavedByDiscounts | priceTotal }}</td>
              </tr>
            </table>
          </div>
        </div>

        <DiscountsSummary :applied-discounts="appliedDiscounts"></DiscountsSummary>
      </div>

      <div class="indented" v-if="cartItems.length > 0">
        <div class="d-flex">
          <div class="hidden-xs-only mr-8">
            <div v-if="$store.getters.enableStempel && !$store.getters.hasStempelInCart"
                 class="mb-4" style="max-width: 318px"
            >
              <SmallStempelkarte></SmallStempelkarte>
            </div>
            <div v-if="$store.state.enableEnterCode">
              <EnterCode></EnterCode>
            </div>
          </div>


          <div class="text-right flex-grow-1">
            <div class="d-inline-block">
              <table class="mySumTable">
                <!--                        <tr>-->
                <!--                            <td>Gesamtgewicht</td>-->
                <!--                            <td>{{gesamtgewicht}} g</td>-->
                <!--                        </tr>-->
                <!--                <tr v-if="totalSavedByDiscounts>0">-->
                <!--                  <td>Zwischensumme</td>-->
                <!--                  <td>{{ $store.getters.cartSum | priceTotal }}</td>-->
                <!--                </tr>-->

                <tr v-if="$store.state.rabattSum > 0" class="rabattColor">
                  <td>Rabattsumme:</td>
                  <td>- {{ $store.state.rabattSum | priceTotal }}</td>
                </tr>

                <!--                <tr v-if="totalSavedByDiscounts>0" class="rabattColor">-->
                <!--                  <td>Rabattsumme:</td>-->
                <!--                  <td>- {{ totalSavedByDiscounts | priceTotal }}</td>-->
                <!--                </tr>-->
                <!--                                v-if="selectedUsecase === 'delivery' || selectedUsecase === 'taxi'"-->
                <!--                                                        <tr>-->
                <!--                                                            <td>Bei lieferung</td>-->
                <!--                                                            <td>{{lieferkosten | price}}</td>-->
                <!--                                                        </tr>-->
                <tr>
                  <td class="pt-2"><h3>Gesamt:</h3>
                    <!--                                        DEBUG
                    Mindestbestell.Takeaway: {{minOrderAmount}}-->
                  </td>
                  <td class="pt-2"><h3 class="text-no-wrap" :class="{rabattColor: totalSavedByDiscounts>0}">
                    {{ total | priceTotal }}</h3></td>
                </tr>
                <!--                <tr v-if="takeAwayTotal !== total">-->
                <!--                  <td><h3>Abholpreis:</h3></td>-->
                <!--                  <td><h3>{{ takeAwayTotal | priceTotal }}</h3></td>-->
                <!--                </tr>-->
                <!--                <tr v-if="deliveryEnabled">-->
                <!--                  <td>-->
                <!--                    &lt;!&ndash;                                        <h3>Lieferpreis (+{{deliveryFee | price}}):</h3>&ndash;&gt;-->
                <!--                    Liefergebühr:-->
                <!--                  </td>-->
                <!--                  <td>-->
                <!--                    Abhängig von der Lieferaddresse-->
                <!--                    &lt;!&ndash;                    <span&ndash;&gt;-->
                <!--                    &lt;!&ndash;                    class="text-no-wrap">{{ $store.getters.appconfig.delivery.deliveryFee | priceTotal }}</span>&ndash;&gt;-->
                <!--                  </td>-->
                <!--                </tr>-->
                <tr v-if="$store.state.onlineServiceFee">
                  <td>
                    Gebühr bei Onlinezalung:
                  </td>
                  <td><span class="text-no-wrap">{{ $store.state.onlineServiceFee | priceTotal }}</span></td>
                </tr>
              </table>
            </div>
            <div v-if="showCurrency">Alle Preisangaben inkl. MwSt.</div>

          </div>
        </div>

        <div v-if="$store.getters.enableStempel && !$store.getters.hasStempelInCart"
             class="hidden-sm-and-up mt-3 mb-4 text-center"
        >
          <SmallStempelkarte></SmallStempelkarte>
        </div>
        <div v-if="$store.state.enableEnterCode"
             class="hidden-sm-and-up mt-3 text-center"
        >
          <EnterCode></EnterCode>
        </div>
      </div>


      <div class="indented myWarning" v-if="showMinHint && $store.getters.payerSum < minOrderAmount">
        <div>Es fehlen noch <strong>{{
            minOrderAmount - $store.getters.payerSum |
              price
          }}</strong>
          für den<br><strong>Mindestbestellwert von {{ minOrderAmount |price }}</strong> für
          {{ describeUsecase }}
        </div>
        <!--                <div>-->
        <!--                    <router-link :to="{ name: 'Filialen' }">(Filiale ändern)</router-link>-->
        <!--                </div>-->
        <div></div>
        <!--                <div v-if="$store.getters.cartSum > 0" class="text-center"-->
        <!--                     style="position: absolute; bottom: -28px; left: 0; width: 100%"><strong>&#45;&#45; ODER &#45;&#45;</strong></div>-->
      </div>
      <div class="indented myWarning" v-if="$store.getters.orderingEnabled === false">
        <h3 class="text-center">Aktuell sind keine Online Bestellungen möglich!</h3>
        Versuche es in ein paar Minuten erneut.
      </div>
      <!--            <div class="indented takeawayOption text-center"-->
      <!--                 v-if="$store.getters.cartItems.length > 0 && $store.getters.orderingEnabled && $store.getters.cartSum < minOrderAmount">-->
      <!--                <div class="spacer-25"></div>-->
      <!--                <div class="spacer-15"></div>-->
      <!--                <div class="d-inline-block">-->
      <!--                    <v-btn block large dark class="text-none checkoutButtonAnimationExtreme"-->
      <!--                           v-if="$store.getters.cartSum > 0"-->
      <!--                           @click.native.passive="goforTakeaway">Bestellen zum Abholen in der Filiale-->
      <!--                    </v-btn>-->
      <!--                </div>-->
      <!--            </div>-->
    </v-container>

    <v-container v-if="!showButton">
      <v-btn class="btn-mini" @click="$ebus.$emit('forceReload')">Seite neu laden</v-btn>
      <!--            <div class="indented text-left">-->
      <!--                <div class="d-inline-block" v-if="$store.getters.orderingEnabled === false ||-->
      <!--                                                           $store.getters.payerSum < minOrderAmount">-->
      <!--                    <div class="spacer-15"></div>-->
      <!--                    <v-btn @click.native.passive="gotoSpeisen" class="text-none btn-df okBtn">-->
      <!--                        Weitere Artikel-->
      <!--                    </v-btn>-->
      <!--                    <v-btn-->
      <!--                            v-if="$store.getters.orderingEnabled"-->
      <!--                            @click.native.passive="clickGotoOrder" class="text-none btn-df okBtn ml-2">-->
      <!--                        Bestellen-->
      <!--                    </v-btn>-->
      <!--                </div>-->
      <!--                <div v-else class="d-inline-block text-no-wrap mt-2">-->
      <!--                    &lt;!&ndash;                        <v-btn block large&ndash;&gt;-->
      <!--                    &lt;!&ndash;                               dark&ndash;&gt;-->
      <!--                    &lt;!&ndash;                               class="text-none checkoutButtonAnimationExtreme"&ndash;&gt;-->
      <!--                    &lt;!&ndash;                               :class="{greenPulsing: $store.getters.orderingEnabled &&&ndash;&gt;-->
      <!--                    &lt;!&ndash;                               $store.getters.cartSum >= minOrderAmount}"&ndash;&gt;-->
      <!--                    &lt;!&ndash;                               @click.native.passive="doOrder">&ndash;&gt;-->
      <!--                    &lt;!&ndash;                            Bestellen&ndash;&gt;-->
      <!--                    &lt;!&ndash;                        </v-btn>&ndash;&gt;-->

      <!--                    <div class="d-inline-block">-->
      <!--                        <v-btn @click.native.passive="gotoSpeisen"-->
      <!--                               class="text-none btn-df okBtn mr-4 ml-2 hidden-xs-only"-->
      <!--                        >Weitere Artikel-->
      <!--                        </v-btn>-->
      <!--                    </div>-->

      <!--                    <div class="d-inline-block mt-7" v-if="$store.getters.orderingEnabled">-->
      <!--                        <v-btn class="btn-df okBtn" rounded-->
      <!--                               v-if="cartItems.length > 0"-->
      <!--                               @click.native.passive="clickGotoOrder">-->
      <!--                            &lt;!&ndash;                               @click.native.passive="clickStartOrder">&ndash;&gt;-->
      <!--                            &lt;!&ndash;                            @click.native.passive="clickStartOrder">&ndash;&gt;-->
      <!--                            <v-icon left medium>mdi-cart-arrow-right</v-icon>-->
      <!--                            Bestellen-->
      <!--                        </v-btn>-->
      <!--                    </div>-->

      <!--                    <div class="spacer-15 hidden-sm-and-up"></div>-->
      <!--                    <div class="d-inline-block">-->
      <!--                        <v-btn @click.native.passive="gotoSpeisen" class="text-none btn-df okBtn hidden-sm-and-up"-->
      <!--                        >-->
      <!--                            Weitere Artikel-->
      <!--                </v-btn>-->
      <!--                    </div>-->
      <!--                </div>-->

      <!--                <div class="spacer-15"></div>-->
      <!--                &lt;!&ndash;                <v-btn color="primary" rounded class="text-none btn-df" style="margin-bottom: 10px"&ndash;&gt;-->
      <!--                &lt;!&ndash;                       @click.native.passive="gotoProducts"&ndash;&gt;-->
      <!--                &lt;!&ndash;                       v-if="$store.getters.cartItems.length === 0">&ndash;&gt;-->
      <!--                &lt;!&ndash;                    Artikel hinzufügen&ndash;&gt;-->
      <!--                &lt;!&ndash;                </v-btn>&ndash;&gt;-->
      <!--            </div>-->
    </v-container>

    <div class="spacer-40"></div>


    <!--        //FIXME enable as soon as we have more than one usecase-->
    <!--        <v-container grid-list-xl id="usecases" v-if="$store.getters.cartItems.length > 0">-->
    <!--            <v-layout row wrap>-->
    <!--                &lt;!&ndash;                <v-flex xs12 class="text-center">&ndash;&gt;-->
    <!--                &lt;!&ndash;                    <div class="nice-title">Wähle zwischen Abholung und Lieferung:</div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                </v-flex>&ndash;&gt;-->
    <!--                <v-flex xs12 md6 lg4>-->
    <!--                    <div class="usecase  highlight myBoxShadow" @click.passive="chooseUsecase('takeAway')">-->
    <!--                        <div class="myDisplay1 text-center">Zum Abholen</div>-->
    <!--                        <div class="spacer-15"></div>-->
    <!--                        <p class="text-center">Du kannst deine Bestellung bei mir zu Hause in Maxdorf abholen, nach-->
    <!--                            Terminvereinbarung von Monatgs bis Freitags.</p>-->
    <!--                        <div class="choose">-->
    <!--                            <p class="text-center bfont">Summe: {{takeAwayTotal | price}}</p>-->
    <!--                            <v-btn large-->
    <!--                                   dark-->
    <!--                                   class="text-none btn-df accentBtn" rounded-->
    <!--                            >-->
    <!--                                &lt;!&ndash;                                        :class="{greenPulsing: $store.getters.orderingEnabled &&&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                        $store.getters.cartSum >= minOrderAmount}"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                           @click.native.passive="gotoAholung">&ndash;&gt;-->
    <!--                                Auswählen-->
    <!--                            </v-btn>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </v-flex>-->
    <!--                <v-flex xs12 md6 lg4>-->
    <!--                    <div class="usecase  highlight myBoxShadow" @click.passive="chooseUsecase('delivery')">-->
    <!--                        <div class="myDisplay1 text-center">Zum Liefern</div>-->
    <!--                        <div class="spacer-15"></div>-->
    <!--                        <p class="text-center">Deine Bestellung wir per DHL direkt zu dir nach Hause geliefert.</p>-->
    <!--                        <div class="choose">-->
    <!--                            <p class="text-center bfont">Summe: {{total | priceTotal}}</p>-->
    <!--                            <v-btn large-->
    <!--                                   dark-->
    <!--                                   class="text-none btn-df accentBtn" rounded-->
    <!--                            >-->
    <!--                                &lt;!&ndash;                                        :class="{greenPulsing: $store.getters.orderingEnabled &&&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                        $store.getters.cartSum >= minOrderAmount}"&ndash;&gt;-->
    <!--                                &lt;!&ndash;                                           @click.native.passive="gotoAholung">&ndash;&gt;-->
    <!--                                Auswählen-->
    <!--                            </v-btn>-->
    <!--                        </div>-->
    <!--                    </div>-->
    <!--                </v-flex>-->
    <!--                &lt;!&ndash;                 <v-flex xs12 md6 lg4>&ndash;&gt;-->
    <!--                &lt;!&ndash;                    <div class="usecase fade">&ndash;&gt;-->
    <!--                &lt;!&ndash;                        <div class="nice-title  text-center">Lieferung</div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                        <p>Von Freitag bis Sonntag liefern wir frische Backwaren <b>direkt an Ihre Haustür</b>. Es wäre&ndash;&gt;-->
    <!--                &lt;!&ndash;                            schön, wenn Sie eine Stofftasche an die Tür hängen.</p>&ndash;&gt;-->
    <!--                &lt;!&ndash;                        <div class="choose">&ndash;&gt;-->
    <!--                &lt;!&ndash;                            <v-btn large&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   dark&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   class="text-none checkoutButtonAnimationExtreme"&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   :class="{greenPulsing: $store.getters.orderingEnabled &&&ndash;&gt;-->
    <!--                &lt;!&ndash;                               $store.getters.cartSum >= minOrderAmount}"&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   @click.native.passive="chooseUsecase('taxi')">&ndash;&gt;-->
    <!--                &lt;!&ndash;                                Weiter&ndash;&gt;-->
    <!--                &lt;!&ndash;                            </v-btn>&ndash;&gt;-->
    <!--                &lt;!&ndash;                        </div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                    </div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                </v-flex>&ndash;&gt;-->
    <!--                &lt;!&ndash;                 <v-flex xs12 md6 lg4>&ndash;&gt;-->
    <!--                &lt;!&ndash;                    <div class="usecase fade">&ndash;&gt;-->
    <!--                &lt;!&ndash;                        <div class="nice-title  text-center">Versand</div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                        <p>Ausgewählte Produkte versenden wir <b>deutschlandweit</b> an eine Adresse Ihrer Wahl.</p>&ndash;&gt;-->
    <!--                &lt;!&ndash;                        <div class="choose">&ndash;&gt;-->
    <!--                &lt;!&ndash;                            <v-btn large&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   dark&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   class="text-none checkoutButtonAnimationExtreme"&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   :class="{greenPulsing: $store.getters.orderingEnabled &&&ndash;&gt;-->
    <!--                &lt;!&ndash;                               $store.getters.cartSum >= minOrderAmount}"&ndash;&gt;-->
    <!--                &lt;!&ndash;                                   @click.native.passive="chooseUsecase('delivery')">&ndash;&gt;-->
    <!--                &lt;!&ndash;                                Weiter&ndash;&gt;-->
    <!--                &lt;!&ndash;                            </v-btn>&ndash;&gt;-->
    <!--                &lt;!&ndash;                        </div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                    </div>&ndash;&gt;-->
    <!--                &lt;!&ndash;                </v-flex>&ndash;&gt;-->
    <!--            </v-layout>-->
    <!--        </v-container>-->

    <!--        <div class="spacer-25"></div>-->
    <!--        <div class="text-center">-->
    <!--            <v-btn color="primary" rounded class="text-none btn-df" @click.native.passive="gotoProducts"-->
    <!--            >-->
    <!--                &lt;!&ndash;                v-if="$store.getters.cartItems.length > 0"&ndash;&gt;-->
    <!--                Weitere Artikel-->
    <!--            </v-btn>-->
    <!--        </div>-->

    <div class="spacer-25"></div>

    <notes-dialog :dialog="notesDialog" :item="selectedItem"
                  @close="notesDialog = false; rememberItems();"></notes-dialog>

    <tischnummer-dialog :dialog="showTischnummer"
                        @tnumberselected="tnumberselected"
                        @close="showTischnummer = false"></tischnummer-dialog>

    <SelectPickupTimeDialog :dialog="showSelectPickupTime"
                            @close="showSelectPickupTime=false"
    ></SelectPickupTimeDialog>

    <FixOrderNow v-if="itemsCount > 0 && showButton && $store.state.cartId.length === 0"
                 @ordernow="doOrder"
                 @more="gotoSpeisen"
                 @next="clickGotoOrder(true)"
    ></FixOrderNow>

    <div class="pt-10 text-center" v-if="$store.getters.isKiosk">
      <v-btn class="btn-mini neuStartenScale12" rounded @click.native.passive="$ebus.$emit('resetKioskReload')">
        NEU STARTEN
      </v-btn>
    </div>

    <div v-if="$store.getters.isKiosk" @click="kioskFallbackExit" class="kioskFallbackExit"></div>

    <!--        <qsignal class="hide-md"></qsignal>-->

    <div v-if="showKeyboard" class="fixedVirtualKeyboard">
      <div class="superCenter">
        <VirtualKeyboard
          :label="keyboardLabel"
          @enter="keyboardEnter"
          @close="showKeyboard = false"
        ></VirtualKeyboard>
      </div>
    </div>

    <template v-if="$store.getters.isKiosk">
      <NumberInputDialog code-title="Enter cashier code" code-subtitle=""
                         :dialog="showCashierCodeDialog"
                         :acceptable-codes="['337701']" @close="showCashierCodeDialog = false"
                         @validationSuccess="cashierCodeSuccess">
      </NumberInputDialog>
    </template>

    <ZvtDialog
      :total="total"
      :dialog="showZvtDialog" @close="showZvtDialog=false"></ZvtDialog>

  </div>
</template>

<script>
import * as appManager from '@/vendor/appManager'
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as xhr from '../api/xhr.js'
import * as util from '../vendor/util'
import {cloneMe, roundToTwo} from '../vendor/util'
// import * as plausi from '../vendor/plausi'
import * as qconst from '../vendor/qconstants'
import {
  alwaysAskForTableNumberInhouse,
  enableDigitalOhnePay,
  enableDigitalPay,
  enableFlexCodes,
  enableKioskInhousePayMitTip,
  getDisplayKioskPaymentMethods,
  getDisplayPaymentMethods,
  hideCurrency
} from '../vendor/qconstants'
import * as bootstrap from '../vendor/bootstrap'
import NotesDialog from "../dialogs/NotesDialog";
import TischnummerDialog from "../dialogs/TischnummerDialog";
import EnterCode from "../components/EnterCode";
import ListEnteredCodes from "../components/ListEnteredCodes";
import FixOrderNow from "../components/FixOrderNow";
import SmallStempelkarte from "../stempelkarte/SmallStempelkarte";
import * as firebaseUtil from "@/firebase/firebaseUtil";
import {itemsContainsTicket} from "@/vendor/itemUtil";
import {getErrorDetails} from "@/util/globalErrorHandler";
import OrderModeSwitcher from "../orderModeSwitch/OrderModeSwitcher.vue";
import SelectPickupTimeDialog from "../dialogs/SelectPickupTimeDialog.vue";
import {getGlobalValue} from "../util/globalState";
import ZvtDialog from "../dialogs/ZvtDialog.vue";
import VirtualKeyboard from "../kiosk/VirtualKeyboard.vue";
import {getAppliedDiscountsDetail} from "../discounts/discountsUtil";
import DiscountsSummary from "../discounts/DiscountsSummary.vue";
import NumberInputDialog from "../androidkiosk/NumberInputDialog.vue";
// import CatSlider from "../components/CatSlider";
// import Qsignal from "../components/qsignal";

// import myline from '../components/myline'

export default {
  components: {
    NumberInputDialog,
    DiscountsSummary,
    VirtualKeyboard,
    ZvtDialog,
    SelectPickupTimeDialog,
    OrderModeSwitcher,
    SmallStempelkarte,
    FixOrderNow,
    ListEnteredCodes,
    EnterCode,
    TischnummerDialog,
    // CatSlider,
    NotesDialog
    // text-center
    // myline
  },
  data() {
    return {
      showCashierCodeDialog: false,
      userSelectedTableNumber: 0,
      showKeyboard: false,
      keyboardLabel: '',
      clientId: '',
      userSelectedInhouseNowOrLater: '',
      showCurrency: !hideCurrency,
      orderCompleted: false,
      fastUnload: false,
      // cartItems: JSON,
      // cartSum: 0,
      selectedItem: {nameToDisplay: '', notes: ''},
      notesDialog: false,

      showZvtDialog: false,

      selectedInhouseWithPay: false,

      selectedPlz: '',
      // relevantDeliveryAddress: {
      //     street: '',
      //     plz: '',
      //     city: '',
      //     etage: '',//optional
      // },

      selectedUsecase: '',//qconst.usecase$takeAway,// initial value
      isBeforeTimeout: true,

      gesamtgewicht: 0,
      lieferkosten: 0, //bleibt hier immer auf 0; stattessen wird deliveryFee computed benutzt
      // timeUpdater: null,

      showTischnummer: false,
      showSelectPickupTime: false,

      //testSource: 'https://yt3.ggpht.com/a-/AAuE7mBDq4xMH1_n2OtxrMA7M2e2ZwLQP4013_EDWw=s900-mo-c-c0xffffffff-rj-k-no'
    }
  },
  computed: {
    dynamicEnableInhouseOhnePay() {
      let a = store.getters.enableInhouseOhnePay;
      return a || this.total === 0;
    },
    dynamicEnableTakeawayOhnePay() {
      let a = store.getters.enableTakeawayOhnePay;
      return a || this.total === 0;
    },
    dynamicEnableTakeawayPay() {
      let a = store.getters.enableTakeawayPay;
      return a && this.total > 0;
    },
    dynamicEnableInhousePay() {
      let a = store.getters.enableInhousePay;
      return a && this.total > 0;
    },

    showOrderModeSwitcher() {
      return store.getters.showOrderModeSwitcher
    },

    appliedDiscounts() {
      return getAppliedDiscountsDetail(
        store.getters.cartItems,
        store.getters.discounts,
        store.getters.selectedOrderModeByUser,
      );
    },
    totalSavedByDiscounts() {
      return roundToTwo(this.appliedDiscounts.reduce((sum, d) => sum + d.absoluteAmount, 0));
    },

    displayOrderModeSelection() {
      const uc = store.getters.selectedOrderModeByUser;
      this.init();
      return uc;
    },

    availableKioskOrderModes() {
      let modes = [];

      if (store.getters.enableKioskInhouseOhnePay) {
        modes.push('KioskInhouseOhnePay');
      }
      if (store.getters.enableKioskInhouseMitPay) {
        modes.push('KioskInhouseMitPay');
      }
      if (this.dynamicEnableTakeawayOhnePay) {
        modes.push('KioskTakeAwayOhnePay');
      }
      if (store.getters.enableKioskTakeAwayMitPay) {
        modes.push('KioskTakeAwayMitPay');
      }

      if (store.getters.enableKioskInhouseOhnePay || store.getters.enableKioskInhouseMitPay) {
        modes.push('inhouse');
      }
      if (this.dynamicEnableTakeawayOhnePay || store.getters.enableKioskTakeAwayMitPay) {
        modes.push('takeAway');
      }
      return modes;
    },

    selfServiceEnabled() {
      return this.$store.getters.selfServiceEnabled;
    },
    isSimpleCase() {
      if (store.getters.isKiosk) {
        return false;
      }
      return store.getters.inhouse && store.getters.table && this.dynamicEnableInhouseOhnePay && !this.dynamicEnableInhousePay
        && !this.$store.getters.selfServiceEnabled;
    },
    itemsCount() {
      let i = 0;
      for (let item of store.getters.cartItems) {
        if (item.id && (item.id.startsWith('special') || item.id.startsWith('stempel-'))) {
          continue;
        }
        i += item.count;
      }
      return i;
    },
    showButton() {
      return this.$store.getters.secToken.length > 1;
      // if (store.getters.inhouse) {
      //     return true;
      // }
      // return ((this.dynamicEnableTakeawayPay || store.getters.enableTakeawayOhnePay)
      //     && (!store.getters.enableDeliveryPay && !store.getters.enableDeliveryOhnePay))
      //
      //     ||
      //
      //     ((store.getters.enableDeliveryPay || store.getters.enableDeliveryOhnePay)
      //         && (!this.dynamicEnableTakeawayPay && !enableTakeawayOhnePay.enableDeliveryOhnePay));
    },

    showMinHint() {
      // if (this.selectedUsecase === qconst.usecase$takeAway) {
      //     return store.getters.selectedStore.minOrderAmount > 0;
      // }
      // return false;
      return true;
    },

    describeUsecase() {
      return 'eine Bestellung';
      // if (this.selectedUsecase === qconst.usecase$takeAway) {
      //     return 'eine Bestellung in der Filiale '
      //         + store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
      // }
      // if (this.selectedUsecase === qconst.usecase$delivery) {
      //     return 'eine Lieferung';
      // }
    },

    minOrderAmount() {
      if (store.getters.inhouse) {
        return 0;//0.5;
      }
      if (this.selectedUsecase === qconst.usecase$takeAway) {
        let m = store.getters.appconfig.takeAway.minOrderAmount - store.state.rabattSum;
        if (m < 1.5 && this.dynamicEnableTakeawayPay) {
          m = 1.5
        }
        return m;
      } else if (this.selectedUsecase === qconst.usecase$delivery) {
        return 0; // mindestbestellwert ist abhängig vom liefergebiet und
        // kann erst abhängig von der Lieferadress ermitelt, werden, also erst im Checkout

        // let m = store.getters.appconfig.delivery.minOrderAmount - store.state.rabattSum;
        // if (m < 1.5 && store.getters.enableDeliveryPay) {
        //   m = 1.5
        // }
        // return m;
      } else {
        return 0;
      }
    },

    takeawayEnabled() {
      return store.getters.enableTakeawayOhnePay || this.dynamicEnableTakeawayPay;
    },

    deliveryEnabled() {
      return store.getters.enableDeliveryOhnePay || store.getters.enableDeliveryPay;
    },

    deliveryFee() {
      if (store.getters.inhouse) {
        return 0;//0.5;
      }
      return 0; // deliveryFee ist abhängig vom liefergebiet und
      // kann erst abhängig von der Lieferadresse ermitelt, werden, also erst im Checkout
      // let f = store.getters.appconfig.delivery.deliveryFee;
      // if (!f) {
      //   f = 0;
      // }
      //individuell
      const f = 0;
      if (store.getters.cartSum >= 20) {
        f = 0;
      }
      return f;
    },


    cartItems() {
      return store.getters.cartItems;
    },

    cartSum() {
      return store.getters.cartSum;
    },

    total() {
      return store.getters.payerSum + this.lieferkosten - this.totalSavedByDiscounts;
    },

    takeAwayTotal() {
      // if(store.state.takeAwayPayerSum < store.getters.payerSum){
      return store.state.takeAwayPayerSum;
      // }else{
      //     return store.getters.payerSum + store.getters.relevantArea.fee;
      // }
    }
    // minDiff() {
    //     return store.getters.appconfig.takeAway.minOrderAmount - store.getters.cartSum;
    // }
  },
  created() {
    ebus.$on('userOrderModeSwitchUpdated', () => {
      if (this.hasConfirmedOnce) {
        this.clickGotoOrder(true);
      }
    });

    ebus.$on('cb-finishPickupTimeSelection', () => {
      this.selectedUsecase = qconst.usecase$tableOrdering
      this.finishInhouseUsecase();
    });

    ebus.$on('cb-inhouseNowOrLater', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        this.userSelectedInhouseNowOrLater = 'now';
      } else {
        this.userSelectedInhouseNowOrLater = 'later';
      }
      this.continueDoOrder();
    });

    ebus.$on('cb-inhouseOrTakeaway', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        this.selectedUsecase = qconst.usecase$tableOrdering;
        this.finishInhouseUsecase();
      } else {
        this.selectedUsecase = qconst.usecase$takeAway;
        this.finishComplexer();
      }
    });

    ebus.$on(qconst.notify$appLoaded, () => {
      this.init();
    });

    ebus.$on('cb-continueDoOrder', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        this.continueDoOrder();
      }
    });

    ebus.$on('cb-continueStempel', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        ebus.$emit('addStempelToCart');
        // this.continueDoOrder();
      } else {
        this.continueDoOrder();
      }
    });

    ebus.$on('cb-inhouseWithPay', (yesOrNo) => {
      this.selectedInhouseWithPay = !!(yesOrNo === 'yes');

      if (store.getters.isKiosk) {
        if (this.selectedInhouseWithPay) {

          // this.showZvtDialog = true;

          if (enableKioskInhousePayMitTip) {
            this.$router.push({name: 'CheckoutKioskInhouseTip'});
          } else {
            this.$router.push({name: 'CheckoutKioskInhouse'});
          }
        } else {
          this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
        }
        return;
      }

      if (this.selectedInhouseWithPay) {
        if (qconst.enableAllReady) {
          this.showHintForGroup();
        } else {
          if (!store.getters.payerSum) {
            this.$router.push({
              name: 'checkout' + qconst.usecase$tableOrdering
            });
          } else {
            this.$router.push({
              name: 'checkout' + qconst.usecase$tableOrdering + 'WithPay'
                + (store.state.enableTip ? 'Tip' : '')
            });
          }
        }
      } else {
        if (qconst.enableAllReady) {
          this.showHintForGroup();
        } else {
          if (this.selfServiceEnabled) {
            this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
          } else {
            if (this.$ls.get('userSelectedTargetTime') || store.state.enableOrderModeSelection) {
              this.$router.push({
                name: 'checkout' + qconst.usecase$tableOrdering
              });
            } else {
              this._saveOrder(0);
            }
          }
        }
      }
    });

    ebus.$on('cb-takeAwayWithPay', (yesOrNo) => {
      const selectedTakeawayWithPay = !!(yesOrNo === 'yes')

      if (store.getters.isKiosk) {
        if (selectedTakeawayWithPay) {
          this.$router.push({name: 'CheckoutKioskTakeAway'});
        } else {
          this.$router.push({name: 'checkouttakeAway'});
        }
        return;
      }

      if (selectedTakeawayWithPay) {
        if (store.getters.isKiosk) {
          this.$router.push({name: 'CheckoutKioskTakeAway'});
          return;
        }

        this.$router.push({name: 'checkout' + qconst.usecase$takeAway + 'WithPay'});
      } else {
        this.$router.push({name: 'checkout' + qconst.usecase$takeAway});
      }
    });

    ebus.$on('cb-selectTakeawayOrDelivery', (yesOrNo) => {
      const selectTakeawayOrDelivery = !!(yesOrNo === 'yes');

      if (selectTakeawayOrDelivery) {
        this.selectedUsecase = qconst.usecase$takeAway;
      } else {
        this.selectedUsecase = qconst.usecase$delivery;
      }
      this.doOrder();
    });

    ebus.$on('cb-deliveryWithPay', (yesOrNo) => {
      if (!!(yesOrNo === 'yes')) {
        this.$router.push({name: 'checkout' + qconst.usecase$delivery + 'WithPay'});
      } else {
        this.$router.push({name: 'checkout' + qconst.usecase$delivery});
      }
    });

    ebus.$on('cb-hintForGroup', (yesOrNo) => {
      if (yesOrNo === 'yes') {
        if (store.getters.payerSum && this.selectedInhouseWithPay) {
          this.$router.push({
            name: 'checkout' + qconst.usecase$tableOrdering + 'WithPay'
              + (store.state.enableTip ? 'Tip' : '')
          });
        } else {
          this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
        }
      }
    });
// ebus.$on('cb-asGuest', (yesOrNo) => {
//     if (yesOrNo === 'yes') {
//         //Als Gast bestellen
//         this.$ls.set('asGuest', 'true');
//         this.clickOrder();
//     } else {
//         //Als Kunde bestellen
//         store.commit('showLoading', false);
//         this.$ls.remove('asGuest');
//         if (firebaseUtil.getUser()) {
//             this.clickOrder();
//         } else if (bootstrap.hasAccount()) {
//             store.commit('currentNext', 'Korb');
//             console.log('summary goto signin');
//             this.$router.push({name: 'Anmelden'});
//         } else {
//             store.commit('currentNext', 'Korb');
//             console.log('summary goto register');
//             this.$router.push({name: 'Registrierung'});
//         }
//     }
// });
  },

  beforeMount() {
    this.$ls.set('clientId', util.generateClientId());
    console.log('beforeMount RRRRRRRRRRRRRRRRRRRRRRRR');
  },

  mounted() {
    store.commit('showLoading', false);
    store.state.hideScroll = true;
    this.asGuest = !!this.$ls.get('asGuest', true);
    this.init();
    setTimeout(() => {
      util.jumpToTop();
    }, 120);

    if (this.deliveryEnabled) {
      this.selectedUsecase = '';
    }

    ebus.$emit('subscribeForPush');
    ebus.$emit('loadAppconfig');

    // setTimeout(() => {
    //     if (store.state.cartId.length > 0) {
    //         store.commit('cartId', '');
    //         if (this.dynamicEnableTakeawayPay) {
    //             this.$router.push({name: 'checkout' + qconst.usecase$takeAway + 'WithPay'});
    //         } else {
    //             this.$router.push({name: 'checkout' + qconst.usecase$takeAway});
    //         }
    //     }
    // }, 400);
    // firebaseUtil.gevent('view_cart', {
    //     currency: 'EUR',
    //     value: this.total,
    //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems))
    // });
  },

  destroyed() {
    store.state.hideScroll = false;
    util.clearEvents([
      'userOrderModeSwitchUpdated',
      'cb-finishPickupTimeSelection',
      'cb-inhouseNowOrLater',
      'cb-continueStempel',
      'cb-continueDoOrder',
      'cb-inhouseWithPay',
      'cb-takeAwayWithPay',
      'cb-deliveryWithPay',
      'cb-inhouseOrTakeaway',
      'cb-continueDoOrder',
      'cb-selectTakeawayOrDelivery',
      'cb-hintForGroup',
    ]);
    // this.selectedUsecase = '';
    // util.clearTheInterval(this.timeUpdater);
  },

  methods: {

    cashierCodeSuccess() {
      this.$router.push({name: 'SetupKiosk'});
    },

    kioskFallbackExit() {
      this.showCashierCodeDialog = true;
      setTimeout(() => {
        this.showCashierCodeDialog = false;
      }, 8 * 1000);
    },

    keyboardEnter(text) {
      if (this.keyboardLabel === 'Anmerkung') {
        this.selectedItem.notes = text ? text.trim() : '';
      }
      this.showKeyboard = false;
    },

    logPurchase() {
    },
    // directToStoreSelection(withNote) {
    //     if (withNote) {
    //         ebus.$emit('showInfo', {
    //             title: 'Bitte wähle zuerst eine Filiale aus, in der du deine Bestellung abholen möchtest',
    //             text: '',
    //         });
    //     }
    //     this.$store.commit('showDialogContainer', true);
    //     this.$store.commit('selectedDialog', 'SelectFiliale');
    //     // ebus.$emit('goto', {name: 'Filialen', params: {query: {select: true}}});
    // },
    init() {
      this.updateLieferkosten();

      // // store.commit('currentRoute', 'Korb');
      // ebus.$emit('updateRelevantArea');
      // // let restName = '' + store.state.restaurantData.restaurantName;
      // // store.commit('headerTitle', restName);
      //
      // // this.cartItems = store.getters.cartItems;
      // // this.cartSum = store.getters.cartSum;

      // this.updateTime();
      // this.timeUpdater = setInterval(() => {
      //     this.updateTime();
      // }, 10 * 1000);
    },

    hasToSelectUsecase() {
      return (store.getters.enableTakeawayOhnePay || this.dynamicEnableTakeawayPay) && (store.getters.enableDeliveryOhnePay || store.getters.enableDeliveryPay);
    },

    safeUnload() {
      if (this.fastUnload) {
        store.commit('showLoading', false);
        this.orderCompleted = false;
      } else {
        store.commit('showLoading', true);
        setTimeout(() => {
          store.commit('showLoading', false);
          this.orderCompleted = false;
        }, 8 * 1000);
      }
    },
    _saveOrder(retryCount) {
      console.log('_saveOrder');
      if (this.orderCompleted) {
        return;
      }
      this.orderCompleted = true;
      if (!retryCount) {
        retryCount = 0;
      }
      let checkpoints = 0;
      try {
        this.safeUnload();
        let order;
        ++checkpoints;
        order = this.generateOrder();
        ++checkpoints;
        let msg = {
          action: qconst.action$SaveNewOrder,
          order: order,
          // captchaText: '' + this.captchaInput
        };

        let timeout = qconst.withPosApi ? (60 * 1000) : (10 * 1000);
        xhr.xhrSend(true, msg, (reply) => {
          //either ok with orderId or notOk
          // store.commit('showLoading', false);
          ++checkpoints;
          console.log('??? SaveNewOrder reply OK = ' + !!reply.ok);
          if (reply.ok) {
            ++checkpoints;
            this.orderCompleted = true;
            // this.order = reply;

            //final step
            this.safeUnload();
            let finalOrder = Object.assign(util.cloneMe(order), reply);
            delete finalOrder.ok;
            store.commit('updateOrder', finalOrder);

            store.commit('deleteAllCartItems');
            this.logPurchase();
            this.$router.replace({name: 'Bestellung', params: {uniqueOrderId: finalOrder.uniqueOrderId}});

          } else {
            if (reply.captchaError || reply.secTokenError) {
              ebus.$emit('forceReload');
              // this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
            } else if (reply.forceReload) {
              alert('Hinweis: Nach einer kurzen Aktualisierung der App, die automatisch durchgeführt wird,' +
                ' kannst du deine Bestellung abschließen.');
              ebus.$emit('forceReload');
            } else {
              checkpoints += 300;
              // if (reply.captchaError) {
              //     checkpoints += 200;
              //     this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
              // } else {
              // checkpoints += 300;
              this.notifyError('Fehler bei der Verarbeitung der Bestellung', 'Bitte versuche es erneut');
              // }
              // this.reloadCaptcha();
              // checkpoints += 10000;

              // store.commit('showLoading', false);
              //
              ebus.$emit('throwError', getErrorDetails('Error in save new order inhouse, checkpoints: ' + checkpoints));
            }
          }
        }, (err) => {
          checkpoints += 20000;
          ebus.$emit('throwError', getErrorDetails('Transport error in save new order inhouse; checkpoints: ' + checkpoints + ' retryCount: ' + retryCount + ' error:' + err.message));
          // this.notifyError('Fortschritt ' + retryCount + 1 + '/' + 5, '');

          if (!retryCount || retryCount < 2) {
            //retry
            let r = ++retryCount;
            setTimeout(() => {
              this._saveOrder(r);
            }, 2200);
          } else {
            // store.commit('showLoading', false);
            this.notifyError('Verbindungsfehler', 'Bitte versuche es direkt nochmal');
            console.log('Error Verbindungsfehler');
            // setTimeout(() => {
            //     ebus.$emit('reload', true)
            // }, 2500);
          }
        }, timeout);
      } catch (e) {
        checkpoints += 30000;
        ebus.$emit('throwError', getErrorDetails('Exception in save new order inhouse: ' + e.message + '; checkpoints: ' + checkpoints));
        console.log('!!!!! error: ' + e.message);
      }
    },

    hasBadCombiationOfTickets() {
      let hasTicket = false;
      let hasNonTicket = false;
      for (let ci of store.getters.cartItems) {
        if (ci.ticket) {
          hasTicket = true;
        } else {
          hasNonTicket = true;
        }
      }
      if (hasTicket && hasNonTicket) {
        ebus.$emit('showInfo', {
          title: 'Bitte kaufe die Tickets nicht in Kombination mit anderen Artikeln gleichzeitig!',
          text: 'Vielen Dank'
        });
        return true;
      }
      return false;
    },

    clickGotoOrder(initial) {
      if (!this.isInventorySufficient()) {
        return;
      }
      //save applied discounts to store
      store.commit('appliedDiscounts', cloneMe(this.appliedDiscounts));

      if (initial) {
        this.hasConfirmedOnce = true;
        this.selectedUsecase = '';
        this.userSelectedInhouseNowOrLater = '';
        if (!store.getters.isKiosk && enableFlexCodes && alwaysAskForTableNumberInhouse) {
          store.commit('table', 1);
        }
        // if (store.getters.isKiosk) {
        //   this.selectedUsecase = qconst.usecase$tableOrdering;
        // }
      }
      // if (store.getters.isKiosk) {
      //   this.doOrder();
      //   return;
      // }
      if (this.hasBadCombiationOfTickets()) {
        return;
      }

      if (this.allDigital()) {
        if (enableDigitalOhnePay) {
          this.$router.push({name: 'CheckoutDigitalOhnePayment'});
        } else if (enableDigitalPay) {
          this.$router.push({name: 'CheckoutDigitalMitOnlinePayment'});
        }

        return;
      }

      let selectedOrderModeByUser = store.getters.selectedOrderModeByUser;
      if (store.state.enableOrderModeSelection && !selectedOrderModeByUser?.length) {
        ebus.$emit('showOrderModeSwitchDialog', true);
        return;
      }

      if (store.getters.isKiosk) {
        const orderModeOfUser = store.getters.selectedOrderModeByUser;
        if (orderModeOfUser === 'inhouse') {
          if (this.availableKioskOrderModes.includes('KioskInhouseOhnePay')
            && this.availableKioskOrderModes.includes('KioskInhouseMitPay')
          ) {
            //show question
            ebus.$emit('showQuestion', {
              quest: 'Möchtest du direkt bezahlen oder an der Kasse?',
              text: getDisplayKioskPaymentMethods(true),
              yesLabel: 'Direkt bezahlen',
              noLabel: 'An der Kasse ',
              cb: 'cb-inhouseWithPay',
              params: {
                biggerYesButton: store.state.enableBiggerButtonsForOnlinePay,
              },
            });
          } else {
            if (this.availableKioskOrderModes.includes('KioskInhouseOhnePay')) {
              this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
            } else {
              if (enableKioskInhousePayMitTip) {
                this.$router.push({name: 'CheckoutKioskInhouseTip'});
              } else {
                this.$router.push({name: 'CheckoutKioskInhouse'});
              }
            }
          }
        } else {
          //takeAway
          if (this.availableKioskOrderModes.includes('KioskTakeAwayOhnePay')
            && this.availableKioskOrderModes.includes('KioskTakeAwayMitPay')
          ) {
            //show question
            ebus.$emit('showQuestion', {
              quest: 'Möchtest du direkt bezahlen oder an der Kasse?',
              text: getDisplayKioskPaymentMethods(true),
              yesLabel: 'Direkt bezahlen',
              noLabel: 'An der Kasse ',
              cb: 'cb-takeAwayWithPay',
              params: {
                biggerYesButton: store.state.enableBiggerButtonsForOnlinePay,
              },
            });
          } else {
            if (this.availableKioskOrderModes.includes('KioskTakeAwayOhnePay')) {
              this.$router.push({name: 'checkouttakeAway'});
            } else {
              this.$router.push({name: 'CheckoutKioskTakeAway'});
            }
          }
        }

        return;
      }

      if (!store.getters.inhouse) {
        if (!itemsContainsTicket(store.getters.cartItems)
          && (this.dynamicEnableTakeawayPay || store.getters.enableTakeawayOhnePay)
          && (store.getters.enableDeliveryPay || store.getters.enableDeliveryOhnePay)) {

          if (store.state.enableOrderModeSelection && selectedOrderModeByUser?.length
            && selectedOrderModeByUser !== 'inhouse'
          ) {
            ebus.$emit('cb-selectTakeawayOrDelivery', selectedOrderModeByUser === 'takeAway' ? 'yes' : 'no');
          } else {
            ebus.$emit('showQuestion', {
              quest: 'Bestellung zur Abholung oder Lieferung?',
              text: '',
              yesLabel: 'Abholung',
              noLabel: 'Lieferung',
              // yesAction: null,
              cb: 'cb-selectTakeawayOrDelivery'
            });
          }
          return;
        }
      }

      // if (store.getters.selectedStore.strasse.length < 2) {
      //     this.directToStoreSelection(true);
      //     return false;
      // }
      //
      // //check if ordering is enabled in the selectedStore
      // let s = store.getters.selectedStore;
      // if (!this.orderingEnabled) {
      //     ebus.$emit('showInfo', {
      //         title: 'Bestellungen sind in der Filiale ' +
      //             s.strasse + ', ' + s.plz + ' ' + s.ort + ' aktuell nicht möglicht',
      //         text: 'In der Filialübersicht kannst du sehen, in welchen Filialen Bestellungen möglich sind'
      //     });
      //     return false;
      // }
      this.continueDoOrder();
    },

    checkMinOrderAmount() {
      if (store.getters.inhouse) {
        return true;
      }
      if (store.getters.payerSum && store.getters.payerSum < this.minOrderAmount) {
        ebus.$emit('showInfo', {
          title: 'Bitte beachte den Mindestbestellwert von '
            + util.getLocalPrice(this.minOrderAmount)
        });
        // ebus.$emit('showInfo', {
        //     title: 'Der Bestellwert erreicht nicht den Mindestbestellwert',
        //     text: 'Bitte achte auf den angegebenen Mindestbestellert im Warenkorb!'
        // });
        return false;
      }
      return true;
    },

    generateOrder() {
      try {
        let order = {
          clientId: '' + this.$ls.get('clientId'),
          lastMenuUpdate: this.$ls.get('lastMenuUpdate'),
          onlinePay: false,
          directPay: false,
          sentToPos: false,
          storno: false,
          // authCompleted: false,
          // simulateTransportError: false, // only to simulate transport error,
          asGuest: !!this.asGuest,
          type: 'selfOrder',
          fuid: (firebaseUtil.getFuid() ? firebaseUtil.getFuid() : null),
          btaste: bootstrap.getBtaste(),
          domain: window.location.hostname,
          channel: 'on-the-go',
          usecase: qconst.usecase$tableOrdering,
          // restaurantId: store.getters.restId,
          createdAt: Date.now(),
          table: 0 + store.getters.table,
          //Note: delayInMinutes is irrelevant for pre-orders (asap === false)
          // delayInMinutes: store.getters.delayInMinutes,
          // expectedDelayInMinutes: store.getters.delayInMinutes,
          orderData: util.cloneMe(store.getters.cartItems),
          appliedDiscounts: util.cloneMe(store.getters.appliedDiscounts),
          // company: '' + this.company,
          // userInfo: util.cloneMe(store.state.user),
          // pickupDate: util.cloneMe(this.pickupDate),
          targetTime: Date.now() + (5 * 1000),
          // onlinePay: this.psp !== 'bar' && this.psp !== 'beiAbholung' && this.psp !== '',
          paymentInfo: {
            amount: 0 + this.total,
          },
          psp: 'waiter',
          paymentAuth: {},
          note: '',
          // invoiceAddress: {
          //   company: '' + this.invoiceAddress.company.trim(),
          //   street: '' + this.invoiceAddress.street.trim(),
          //   plz: this.invoiceAddress.plz,
          //   city: '' + this.invoiceAddress.city.trim(),
          //   // etage: '' + this.deliveryAddress.etage.trim(),
          // }
          // deliveryAddress: {
          //     company: '' + this.deliveryAddress.company.trim(),
          //     street: '' + this.deliveryAddress.street.trim(),
          //     plz: '' + this.deliveryAddress.plz.trim(),
          //     city: '' + this.deliveryAddress.city.trim(),
          //     etage: '' + this.deliveryAddress.etage.trim(),
          // }
        };

        let pushToken = this.$ls.get('pushToken');
        if (pushToken) {
          order.pushToken = pushToken;
        }

        if (store.state.orderArea) {
          order.orderArea = '' + store.state.orderArea;
        }

        if (store.getters.enableStempel) {
          order.collectStempel = true;
          order.stempelType = store.getters.stempelType;
        }
        if (this.note) {
          order.note = '' + this.note;
        }

        order.userInfo = this.getUserInfo();

        // if (!this.sameAsInvoiceAddress) {
        //   order.deliveryAddress = {
        //     company: '' + this.deliveryAddress.company,
        //     street: '' + this.deliveryAddress.street,
        //     plz: this.deliveryAddress.plz,
        //     city: '' + this.deliveryAddress.city,
        //     etage: '' + this.deliveryAddress.etage,
        //   };
        // }//else we only submit the invoiceAddress

        util.sanitizeProps(order);

        //add app string
        // if (breakpoints.getCurrentDevice() === 'xs') {
        //     order.app = 'LIEFERMAXX Mobile App'
        // } else {
        //     order.app = 'LIEFERMAXX App'
        // }

        //add operating system
        try {
          order.userAgentData = window.navigator.userAgentData;
        } catch (e) {

        }

        // if (this.onlinePay) {
        //     // order.orderNumber = this.orderNumber;
        //     // order.uniqueOrderId = this.uniqueOrderId;
        //
        //     order.paymentInfo.psp = 'stripe';
        //     // order.paymentInfo.paymentIntentId = this.paymentIntentId;
        //     // order.paymentInfo.paymentMethodId = this.selectedPaymentMethodId;
        // }
        // if (this.usecase === 'delivery') {
        //     if (this.deliveryAddress.etage.length > 0) {
        //         order.deliveryAddress.etage = this.deliveryAddress.etage;
        //     }
        order.paymentInfo.itemsTotal = 0 + store.getters.cartSum;
        // order.paymentInfo.deliveryFee = 0;// + store.state.deliveryFee;
        //     // let fee = null;
        //     // for (let area of store.getters.appconfig.deliveryAreas) {
        //     //     if (area.plz === order.deliveryAddress.plz) {
        //     //         fee = area.fee;
        //     //         break;
        //     //     }
        //     // }
        //     // if (fee === null) {
        //     //     //error
        //     //     this.notifyError('Fehler bei den Lieferkosten');
        //     //     return null;
        //     // }
        //     // order.paymentInfo.amount = this.total;
        // } else {
        // order.pickupStore = util.cloneMe(store.getters.selectedStore);
        // delete order.pickupStore.openingHours;
        // order.storeId = '' + store.getters.selectedStore.filialnummer;
        // }
        return util.cloneAndRemoveAllDisplayKeys(order, ['delay']);
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateOrder: ' + e.message));
        return null;
      }
    },

    getUserInfo() {
      return {
        btaste: bootstrap.getBtaste(),
        fuid: firebaseUtil.getFuid(),
        // name: '' + this.name,
        // email: util.sanitizeEmail(this.email),
        // phone: util.sanitizePhone(this.phone),
      };
    },

    notifyError(text, err) {
      ebus.$emit('info', 'Fehler: ' + text + ' ' + (err || ''));
    },

    showHintForGroup() {
      //show question
      setTimeout(() => {
        ebus.$emit('showQuestion', {
          quest: 'Hinweis für Gruppen',
          text: '<p>In einer Gruppe kann jeder für sich mit seinem eigenen Smartphone bestellen und ' +
            'danach sollte eine Person eurer Wahl den Button <b>WIR SIND FERTIG</b> drücken.</p>' +
            '<p>Der Button wird dir/euch nach der Bestellung angezeigt.</p>',
          yesLabel: 'Ok, vestanden',
          // noLabel: '',
          // yesAction: null,
          cb: 'cb-hintForGroup'
        });
      }, 800);
    },

    tnumberselected(num) {
      this.userSelectedTableNumber = num;
      ebus.$emit('userEnteredTable', num);
      this.doOrder(true);
      // if (this.isSimpleCase && !this.$ls.get('userSelectedTargetTime')) {
      //   this._saveOrder(0)
      // } else {
      //   this.finishComplexer();
      // }
    },

    preEnsureItemsFromUser(cbName) {
      ebus.$emit('showQuestion', {
        quest: 'Bist du sicher, dass die Anzahl von ' +
          '<u class="text-no-wrap">' + this.itemsCount + ' Artikel</u> korrekt ist?',
        text: '<div class="pt-5 biggerFont text-center">Summe: <span class="text-no-wrap">' + this.$options.filters.price(this.total) + '</span></div>',
        yesLabel: 'Ja, definitiv',
        noLabel: 'Nein',
        // yesAction: null,
        cb: cbName,
        params: {
          biggerYesButton: true,
        },
      });
    },

    askForStempel(cbName) {
      ebus.$emit('showQuestion', {
        quest: 'Möchtest du deine Stemplelkarte jetzt einlösen, um ' +
          this.$store.getters.stempelRabattAmount + ' Euro zu sparen?',
        // text: '<div class="pt-5 biggerFont text-center">Summe: <span class="text-no-wrap">' + this.$options.filters.price(this.total) + '</span></div>',
        yesLabel: 'Ja',
        noLabel: 'Später',
        // yesAction: null,
        cb: cbName
      });
    },

    // itemAvailable(item) {
    // return plausi.itemAvailableTomorrow(item);
    // },

    updateGesamtgewicht() {
      let g = 0;
      for (let ci of store.getters.cartItems) {
        if (ci.gramm) {
          g += (ci.gramm * ci.count);
        } else {
          g += (300 * ci.count);
        }
      }
      this.gesamtgewicht = g;
    },

    updateLieferkosten() {
      // let result = 0;

      // this.updateGesamtgewicht();
      //
      // let pack = 0.5;
      // let vsand = 5.49;
      // let anyAll = false;
      //
      // //Produktaußnahmen
      // //1. Schraubflasche 100ml	Maxibrief				3,20 €
      // if (!anyAll) {
      //     let allSchraub100 = true;
      //     for (let itm of store.getters.cartItems) {
      //         if (itm.descriptionDE) {
      //             if (itm.descriptionDE.indexOf('Schraub') !== -1 && itm.descriptionDE.indexOf('100') !== -1) {
      //                 continue;
      //             }
      //         } else {
      //             if (itm.nameToDisplay.indexOf('Schraub') !== -1 && itm.nameToDisplay.indexOf('100') !== -1) {
      //                 continue;
      //             }
      //         }
      //         allSchraub100 = false;
      //     }
      //     if (allSchraub100) {
      //         anyAll = true;
      //         pack = 0;
      //         vsand = 2.70;
      //     }
      // }
      //
      // //2. Herzflasche 50ml 	Maxibrief				3,20 €
      // if (!anyAll) {
      //     let allHerz50 = true;
      //     for (let itm of store.getters.cartItems) {
      //         if (itm.descriptionDE) {
      //             if (itm.descriptionDE.indexOf('Herzfl') !== -1 && itm.descriptionDE.indexOf('50') !== -1) {
      //                 continue;
      //             }
      //         } else {
      //             if (itm.nameToDisplay.indexOf('Herzfl') !== -1 && itm.nameToDisplay.indexOf('50') !== -1) {
      //                 continue;
      //             }
      //         }
      //         allHerz50 = false;
      //     }
      //     if (allHerz50) {
      //         anyAll = true;
      //         pack = 0.5;
      //         vsand = 2.70;
      //     }
      // }
      //
      //
      // //3. Mosaik-CD       		Großbrief bis 500g 		7,95 €
      // if (!anyAll) {
      //     let allMosaikCD = true;
      //     for (let itm of store.getters.cartItems) {
      //         if (itm.descriptionDE) {
      //             if (itm.descriptionDE.indexOf('Mosaik') !== -1){ // && itm.descriptionDE.indexOf('CD') !== -1) {
      //                 continue;
      //             }
      //         } else {
      //             if (itm.nameToDisplay.indexOf('Mosaik') !== -1){// && itm.nameToDisplay.indexOf('CD') !== -1) {
      //                 continue;
      //             }
      //         }
      //         allMosaikCD = false;
      //     }
      //     if (allMosaikCD) {
      //         anyAll = true;
      //         pack = 0.5;
      //         vsand = 1.55;
      //     }
      //     console.log('allMosaikCD = ' + allMosaikCD);
      // }
      //
      //
      //
      // //calculare gesamtgewicht
      // let grammTotal = this.gesamtgewicht;
      // if (grammTotal > 5000) {
      //     vsand = 9.49;
      // } else if (grammTotal > 2000 && vsand < 6.49) {
      //     vsand = 6.49;
      // } else if (grammTotal > 1000 && vsand < 5.49) {
      //     vsand = 5.49;
      // }
      //
      // //calculare liefer / versandkosten
      // console.log('Verpackung = ' + pack);
      // console.log('Versand = ' + vsand);
      // this.lieferkosten = pack + vsand;
      // store.commit('deliveryFee', 0 + this.lieferkosten);
      // // return store.state.deliveryFee;
      // // return store.getters.selectedStore.fee;
    },

    gotoCat(cat) {
      store.state.shouldJump = true;
      this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
    },

    gotoAholung() {
      this.$router.push({name: 'Abholung'});
    },

    // initSlider() {
    //     let foodCats = util.cloneMe(store.getters.foodMenu);
    //     // console.log('so do we have cats??? ' + foodCats.length);
    //     for (let fcat of foodCats) {
    //         if (!fcat.items) {
    //             continue;
    //         }
    //         // for (let item of fcat.items) {
    //         //     let offerAndItem = store.getters.getOfferByItemId(item.id);
    //         //     // item.offered = !!offerAndItem;
    //         //     // if (!!offerAndItem) {
    //         //     //     item.offerId = offerAndItem.offer.id;
    //         //     // }
    //         //     this.applyOfferAndPrices(item, offerAndItem);
    //         // }
    //     }
    //     this.foodCategories = foodCats;
    //     // this.loaded = true;
    // },

    clickStartOrder() {
      util.delayScroll('usecases');
    },

    // updateTime() {
    //     //Abholung nur bis 16:30 Uhr möglich
    //     let now = util.getCurrentRemoteTime();
    //     let h = now.getHours();
    //     let m = now.getMinutes();
    //     // console.log('Now time = ' + h + ' : ' + m);
    //
    //     let takeawayPossible = false;
    //     if (h < 16) {
    //         takeawayPossible = true;
    //     } else if (h === 16) {
    //         takeawayPossible = (m <= 30);
    //     }
    //     this.isBeforeTimeout = takeawayPossible;
    // },

    // gotoWebsite(url) {
    //     let win = window.open(url, '_blank');
    //     win.focus();
    // },

    showCouponInfo(c) {
      ebus.$emit('openCouponInfo', c);
    },

    goforTakeaway() {
      this.doOrder();
    },

    editNotes(item) {
      this.selectedItem = item;
      if (store.getters.isKiosk) {
        this.keyboardLabel = 'Anmerkung';
        this.showKeyboard = true;
        return;
      }
      this.notesDialog = true;
    },

    gotoItem(item) {
      if (window.matchMedia('(min-width: 1265px)').matches) {
        if (item.type === qconst.type$foodOrder) {
          // this.$router.push({name: 'foodItem', params: {foodId: item.id}});
          this.$router.push({
            name: 'Speise',
            params: {itemId: item.id},
            query: {cartItemId: item.cartItemId}
          });
        } else if (item.type === qconst.type$drinkOrder) {
          this.$router.push({
            name: 'Getraenk',
            params: {itemId: item.id},
            query: {cartItemId: item.cartItemId}
          });
        }
      }
    },

    // gotoFoods() {
    //     // store.commit('currentTab', 'tab-1');
    //     this.$router.push({name: 'order'});
    //     // ebus.$emit(qconst.notify$tabSwitched);
    // },

    gotoSpeisen() {
      ebus.$emit('shortcutToFoodMenu');
    },

    displayItemVol(item) {
      if (item.vol.length === 0 || item.vol.toLowerCase().indexOf('standard') !== -1) {
        return '';
      } else {
        return item.vol;
      }
    },

    lazyGoBack() {
      if (this.cartItems.length === 0) {
        this.$router.go(-1);
      }
    },

    deleteCartItem(cartItem) {
      console.log('deleteCartItem 6');
      store.commit('deleteCartItem', cartItem);
      // firebaseUtil.gevent('remove_from_cart', {
      //     currency: 'EUR',
      //     value: cartItem.itemTotal,
      //     items: [util.cloneMe(firebaseUtil.getGitemFromCartItem(cartItem))]
      // });
      this.lazyGoBack();
    },

    rememberItems() {
      let i = util.cloneMe(this.cartItems);
      console.log('rememberItems: ', i);
      ebus.$emit('storeCart', i);
    },

    decrementCartItem(cartItem) {
      console.log('decrementCartItem 2');
      store.commit('decrementCartItem', cartItem);
      // firebaseUtil.gevent('remove_from_cart', {
      //     currency: 'EUR',
      //     value: cartItem.itemTotal,
      //     items: [util.cloneMe(firebaseUtil.getGitemFromCartItem(cartItem))]
      // });
      this.updateLieferkosten();
      this.lazyGoBack();
    },

    incrementCartItem(cartItem) {
      store.commit('incrementCartItem', cartItem);
      this.updateLieferkosten();
    },

    // chooseUsecase(uc) {
    //     try {
    //         store.commit('selectedUsecase', uc);
    //         this.selectedUsecase = uc;
    //         if (uc === qconst.usecase$takeAway) {
    //
    //             //Gebe eine Einführung
    //             // let introAbholung = this.$ls.get('introAbholung', {v: false});
    //             // if (!introAbholung.v) {
    //             //     ebus.$emit('showQuestion', {
    //             //         quest: 'Möchten Sie eine kurze Einführung zu unserem Bestellprozess haben?',
    //             //         yesAction: null,
    //             //         qtext: 'Nach der Einführung können Sie Ihren Bestellvorgang fortsetzen.',
    //             //         yesLabel: 'Zur Einführung',
    //             //         cb: 'cb-introAbholung cb-chooseUsecase'
    //             //     });
    //             //     return;
    //             // }
    //
    //             //Prüfe Verfügbarkeit aller Waren
    //             // let itemsNotAvailable = [];
    //             // for (let itm of store.getters.cartItems) {
    //             //     if (itm.couponCode) {
    //             //         continue;
    //             //     }
    //             //     if (!plausi.itemAvailableTomorrow(itm)) {
    //             //         itemsNotAvailable.push(itm);
    //             //     }
    //             // }
    //             // if (itemsNotAvailable.length > 0) {
    //             //     let names = itemsNotAvailable.map(itm => itm.nameToDisplay);
    //             //     // let filialeName = store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
    //             //     ebus.$emit('showInfo', {
    //             //         title: 'Folgende Waren sind morgen nicht verfügbar: ' + this.$options.filters.stringList(names),
    //             //         text: 'Bitte entfernen Sie nicht verfügbare Waren aus dem Korb.'
    //             //     });
    //             //     util.jumpToTop(true);
    //             //     return;
    //             // }
    //
    //
    //             // //First choose a filiale
    //             // if (!store.getters.selectedStore.strasse) {//|| store.getters.selectedTime.value.length < 1
    //             //     this.$router.push({name: 'Filialen', query: {select: 'true'}});
    //             //     return;
    //             // }
    //
    //             //FIXME 16:30 Uhr => only during dev or demo
    //             // if (!this.isBeforeTimeout) {
    //             //     ebus.$emit('showInfo', {
    //             //         title: 'Heute kann nicht mehr zum Abholen bestellt werden!',
    //             //         text: 'Bitte versuche es Morgen wieder bis spätestens 16:30 Uhr.'
    //             //     });
    //             //     return;
    //             // } else {
    //             this.doOrder();
    //             // }
    //         } else if (uc === qconst.usecase$delivery) {
    //             this.doOrder();
    //         } else {
    //             ebus.$emit('showInfo', {
    //                 title: 'Diese Funktion befindet sich in Vorbereitung und wird demnächst bereitgestellt',
    //                 text: 'Bitte versuche es in ein paar Tagen nochmal!'
    //             });
    //         }
    //     } catch (e) {
    //         console.log('Error Datenprüfung: ' + e.message);
    //         ebus.$emit('info', 'Fehler bei der Datenprüfung');
    //     }
    // },

    continueDoOrder() {
      // alert('continueDoOrder...');

      //note: continueDoOrder wird im Kiosk Modus nie aufgerufen

      //Als Gast bestellen
      this.$ls.set('asGuest', true);

      if (!this.checkMinOrderAmount()) {
        return;
      }

      if (this.allDigital()) {
        this.$router.push({name: 'CheckoutDigitalMitOnlinePayment'});
        return;
      }

      if (store.getters.selectedOrderModeByUser
        && store.getters.selectedOrderModeByUser === 'inhouse') {

        if (store.state.enableOrderModeSelectionWithTime) {
          if (store.getters.table === store.state.defaultInhouseTable) {
            if (this.userSelectedInhouseNowOrLater === 'later') {
              this.showSelectPickupTime = true;
              return;
            } else if (this.userSelectedInhouseNowOrLater === 'now') {
              //do nothing
            } else {
              ebus.$emit('showQuestion', {
                quest: 'Möchtest du direkt bestellen oder für später vorbestellen?',
                text: '',
                yesLabel: 'Jetzt',
                noLabel: 'Für Später',
                cb: 'cb-inhouseNowOrLater'
              });
              return;
            }
          }
        }

        // console.log('store.getters.table=' + store.getters.table
        //   + '  store.state.defaultInhouseTable=' + store.state.defaultInhouseTable
        //   + ' this.userSelectedInhouseNowOrLater=' + this.userSelectedInhouseNowOrLater
        // );

        if (alwaysAskForTableNumberInhouse) {
          if (!this.userSelectedTableNumber) {
            this.showTischnummer = true;
            return;
          }
        }

        if (store.state.enableOrderModeSelection) {
          if (store.getters.table === store.state.defaultInhouseTable
            && (
              this.userSelectedInhouseNowOrLater === 'now'
              || !store.state.enableOrderModeSelectionWithTime
            )) {
            this.showTischnummer = true;
            return;
          }
        }
      } //eof not kiosk

      if (store.getters.inhouse) {
        this.selectedUsecase = qconst.usecase$tableOrdering;

        // if ((this.dynamicEnableTakeawayPay || this.dynamicEnableTakeawayPay)) {
        //   ebus.$emit('showQuestion', {
        //     quest: 'Zum hier essen/trinken (Inhouse) oder mitnehmen (Takeaway)?',
        //     text: '',
        //     yesLabel: 'Inhouse',
        //     noLabel: 'Takeaway',
        //     // yesAction: null,
        //     cb: 'cb-inhouseOrTakeaway'
        //   });
        // } else {
        this.finishInhouseUsecase();
        // }
      } else {
        console.log('finishComplexer in continueDoOrder');
        this.finishComplexer();
      }
    },

    finishInhouseUsecase() {
      if (qconst.forceTableScan) {

        if (this.$store.getters.table > 0) {
          // store.commit('table', this.$store.getters.table);
          if (this.isSimpleCase && !this.$ls.get('userSelectedTargetTime') && !store.state.enableOrderModeSelection) {
            this._saveOrder(0);
          } else {
            this.finishComplexer();
          }
        } else {
          if (qconst.enableFlexCodes) {
            let fs = appManager.getTableFlexState(this.$ls.get('tableFlex'));
            if (fs === 3) {
              ebus.$emit('suggestQrCodeScan');
            } else if (fs === 1) {
              this.showTischnummer = true;
            } else {
              this.showTischnummer = true;
            }
          } else {
            ebus.$emit('suggestQrCodeScan');
          }
        }

      } else {
        this.showTischnummer = true;
      }
    },

    isInventorySufficient() {
      if (!store.state.enableBestand) {
        return true;
      }

      let inventoryData = [];
      if (store.state.enableBestand) {
        inventoryData = getGlobalValue('inventoryData') || [];
        const cartItems = store.getters.cartItems;

        for (let cItem of cartItems) {
          const posId = cItem.posId;
          console.log('addItemToCard check 4.0 for posId: ' + posId);
          let iData = inventoryData.find(i => i.posId === posId);
          if (iData) {
            if (iData.currentStock <= 0) {
              ebus.$emit('showInfo', {
                title: 'Der Artikel <span style="text-decoration: underline;">'
                  + cItem.nameToDisplay + '</span> ist ausverkauft!',
                text: ''
              });
              return false;
            } else if (cItem.posId) {
              const existingCartItems = cartItems.filter(i => i.posId === cItem.posId);
              let cartStock = 0;
              for (let eItem of existingCartItems) {
                cartStock += eItem.count;
              }
              if (cartStock > iData.currentStock) {
                ebus.$emit('showInfo', {
                  title: 'Der Artikel <span style="text-decoration: underline;">'
                    + cItem.nameToDisplay + '</span> ist fast ausverkauft: Nur noch ' + iData.currentStock + ' Artikel verfügbar',
                  text: ''
                });
                return false;
              }
            }
          }
        }
      }


      return true;
    },

    doOrder(tnumberselected) {
      if (!this.isInventorySufficient()) {
        return;
      }

      // alert('doOrder...');
      if (store.getters.isKiosk) {
        this.clickGotoOrder();
        return;
      }

      store.commit('appliedDiscounts', cloneMe(this.appliedDiscounts));

      this.userSelectedInhouseNowOrLater = '';
      if (!tnumberselected && enableFlexCodes && alwaysAskForTableNumberInhouse) {
        store.commit('table', 1);
      }
      let uinfo = store.getters.appconfig.userInfo;
      if (uinfo) {
        ebus.$emit('showInfo', {
          title: '' + uinfo,
          text: ''
        });

        let uil = uinfo.toLowerCase();
        if (uil.indexOf('wartung') !== -1 || uil.indexOf('maintenance') !== -1) {
          ebus.$emit('loadAppconfig');
          return;
        }
      }

      if (this.hasBadCombiationOfTickets()) {
        return;
      }

      if (store.getters.enableStempel
        && store.getters.stempelkarte.punktestand >= 100
        && !store.getters.hasStempelInCart
      ) {
        this.askForStempel('cb-continueStempel');
      } else {
        if (store.getters.inhouse &&
          (this.dynamicEnableInhouseOhnePay || this.dynamicEnableInhousePay)
        ) {
          this.preEnsureItemsFromUser('cb-continueDoOrder');
        } else {
          this.continueDoOrder();
        }
      }
    },
    allDigital() {
      // let digitals = ['9999999'];
      for (let item of this.cartItems) {
        // let posId = item.posId;
        if (!item.ticket && !item.onlineGutschein) {
          return false;
        }
        // if (!digitals.includes(posId)) {
        //     return false;
        // }
      }
      return true;
    },
    finishComplexer() {
      console.log('???? goto checkout');

      let foundCase = false;
      if (this.selectedUsecase === qconst.usecase$tableOrdering) {
        if (store.getters.payerSum && this.dynamicEnableInhousePay) {
          if (this.dynamicEnableInhouseOhnePay) {
            foundCase = true;
            //show question
            ebus.$emit('showQuestion', {
              quest: 'Möchtest du online bezahlen?',
              text: getDisplayPaymentMethods(true),
              yesLabel: 'Ja, online bezahlen',
              noLabel: 'Zahlung '
                + (!!this.selfServiceEnabled ? 'bei Abholung' : 'beim Kellner'),
              // yesAction: null,
              cb: 'cb-inhouseWithPay',
              params: {
                biggerYesButton: store.state.enableBiggerButtonsForOnlinePay,
              },
            });
          } else {
            foundCase = true;
            if (!store.getters.payerSum) {
              this.$router.push({
                name: 'checkout' + qconst.usecase$tableOrdering
              });
            } else {
              this.$router.push({
                name: 'checkout' + qconst.usecase$tableOrdering + 'WithPay'
                  + (store.state.enableTip ? 'Tip' : '')
              });
            }
          }
        } else if (this.dynamicEnableInhouseOhnePay) {
          foundCase = true;
          if (this.selfServiceEnabled || store.state.enableOrderModeSelection || this.$ls.get('userSelectedTargetTime')) {
            this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
          } else {
            this.$router.push({name: 'checkout' + qconst.usecase$tableOrdering});
          }
        }
      } else {
        let hasToSelectUsecase = this.hasToSelectUsecase();

        if (!hasToSelectUsecase) {
          if (store.getters.enableTakeawayOhnePay || this.dynamicEnableTakeawayPay) {
            this.selectedUsecase = qconst.usecase$takeAway;
          } else {
            this.selectedUsecase = qconst.usecase$delivery;
          }
        }

        if (this.selectedUsecase.length > 0) {
          if (this.selectedUsecase === qconst.usecase$takeAway) {
            if (store.getters.payerSum && store.getters.enableTakeawayOhnePay && this.dynamicEnableTakeawayPay) {
              foundCase = true;
              //show question
              ebus.$emit('showQuestion', {
                quest: 'Möchtest du online bezahlen?',
                text: getDisplayPaymentMethods(true),
                yesLabel: 'Ja, online bezahlen',
                noLabel: 'Zahlung bei Abholung',
                // yesAction: null,
                cb: 'cb-takeAwayWithPay',
                params: {
                  biggerYesButton: store.state.enableBiggerButtonsForOnlinePay,
                },
              });
            } else {
              if (this.dynamicEnableTakeawayPay) {
                foundCase = true;
                if (!store.getters.payerSum) {
                  this.$router.push({name: 'checkout' + qconst.usecase$takeAway});
                } else {
                  this.$router.push({name: 'checkout' + qconst.usecase$takeAway + 'WithPay'});
                }

              } else if (store.getters.enableTakeawayOhnePay) {
                foundCase = true;
                this.$router.push({name: 'checkout' + qconst.usecase$takeAway});
              }
            }
          } else if (this.selectedUsecase === qconst.usecase$delivery) {
            if (store.getters.payerSum && store.getters.enableDeliveryOhnePay && store.getters.enableDeliveryPay) {
              foundCase = true;
              //show question
              ebus.$emit('showQuestion', {
                quest: 'Möchtest du online bezahlen?',
                text: getDisplayPaymentMethods(true),
                yesLabel: 'Ja, online bezahlen',
                noLabel: 'Zahlung bei Lieferung',
                // yesAction: null,
                cb: 'cb-deliveryWithPay'
              });
            } else {
              if (store.getters.enableDeliveryPay) {
                foundCase = true;
                if (!store.getters.payerSum) {
                  this.$router.push({name: 'checkout' + qconst.usecase$delivery});
                } else {
                  this.$router.push({name: 'checkout' + qconst.usecase$delivery + 'WithPay'});
                }
              } else if (store.getters.enableTakeawayOhnePay) {
                foundCase = true;
                this.$router.push({name: 'checkout' + qconst.usecase$delivery});
              }
            }
          } else {
            foundCase = true;
            this.$router.push({name: 'checkout' + this.selectedUsecase});
          }
        } else {
          foundCase = true;
          this.clickGotoOrder();
        }
      }
      if (!foundCase) {
        if (this.dynamicEnableInhouseOhnePay || this.dynamicEnableInhousePay) {
          if (store.getters.inhouse) {
            ebus.$emit('showInfo', {
              title: 'Bitte scanne zuerst einen QR-Code auf dem Tisch!',
              text: 'Dadurch erfahren wir, an welchem Tisch du sitzt.'
            });
          } else {
            if (this.dynamicEnableTakeawayPay || store.getters.enableTakeawayOhnePay) {
              ebus.$emit('showInfo', {
                title: 'Leider sind Takeaway-Bestellungen in dieser Filiale derzeit nicht möglich.',
                text: ''
              });
            } else {
              ebus.$emit('showInfo', {
                title: 'Aktuell sind keine Bestellungen möglich.',
              });
            }
          }
        } else {
          if (this.dynamicEnableTakeawayPay || store.getters.enableTakeawayOhnePay) {
            ebus.$emit('showInfo', {
              title: 'Leider sind Takeaway-Bestellungen in dieser Filiale derzeit nicht möglich.',
              text: ''
            });
          } else {
            ebus.$emit('showInfo', {
              title: 'Aktuell sind keine Bestellungen möglich.',
            });
          }
        }
      }
    },
    // askForGuest() {
    //     ebus.$emit('showQuestion', {
    //         quest: 'Möchtest du dich als Kunde registrieren oder nur als Gast bestellen?',
    //         yesAction: null,
    //         qtext: 'Als registrierter Kunde kannst du dich bequem per Facebook, Email oder per Mobilnummer anmelden.',
    //         yesLabel: 'Als Gast',
    //         noLabel: 'Als Kunde',
    //         cb: 'cb-asGuest'
    //     });
    //     store.commit('showLoading', true);
    // }
  }
}
</script>


<style lang="scss" scoped>
@import '../styles/base';

.kioskFallbackExit {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 50px;
  height: 50px;
  z-index: 888;
}

.indented {
  margin: 16px 16px;
}

/*@import '../styles/sharedStyles';*/

/*.highlight {*/
/*color: white;*/
/*}*/

.tableContainer {
  border-radius: $box-border-radius;
  border: 1px solid $color-primary;
  padding: 10px;
  color: $font-color;
}

.table {
  font-weight: bold;
  font-size: 1.2em;
}

.boldHead * {
  font-weight: bold;
}

.tnummer {
  font-size: 3em;
  font-weight: bold;
}

.gang {
  text-decoration: underline;
  display: inline-block;
  margin-right: 2px;
  /*padding: 1px 6px;*/
  /*background-color: black;*/
  /*color: white;*/
}


.bgw {
}

.order-container {
  max-width: 300px;
  width: 70%;
}

.notes {
  font-style: italic;
}

.takeawayOption {
  margin: 0 20px 0 20px;
}

.mySumTable {
  td {
    padding-left: 12px;
    padding-top: 8px;
  }
}

/*.minusImg{*/
/*    width: 25px;*/
/*}*/

/*.plusImg{*/
/*    width: 32px;*/
/*}*/

.counterStuff {
  /*width: 40px;*/
  text-align: center;

  padding: 0;

  .col {
    padding: 0 5px 5px 0;
  }

  img {
    width: 32px;
    height: auto;
    margin: 0 15px;
    /*margin-top: 5px;*/
  }

  /*>>> .v-btn{*/
  /*    width: 32px;*/
  /*    height: 32px;*/
  /*    margin: 0;*/
  /*}*/
}

td.counter {
  width: 27px;
  font-size: 1.2em;
  text-align: center;
}

/* Debug tables */
/*table, th, td {*/
/*    border: 1px solid blue;*/
/*}*/

.itemRow {
  //background-color: $color-darkblue;
  //color: white;
  //@include material-shadow(1);
  border-bottom: 1px solid #666;

}

.pmRow {
  margin: 15px 8px;
  padding: 0;
}

.items {
  /*border-collapse: collapse;*/

  td {
    //background-color: $color-darkblue;
    //color: white;
  }

  .a {
    width: 38px;
  }

  .b {
    width: 85%;
    /*padding-left: 1%;*/
    vertical-align: top;
    padding-bottom: 15px;
  }

  .c {

  }

  .d {

  }

  .e {
    width: 60px;
  }

  .f {
    width: 30px;
  }
}

.displayExtras {
  color: rgba($font-color, 0.8);
}

.myWarning {
  color: red;
  margin: 30px 0;
  /*border: 2px solid red;*/
  padding: 8px 0;
  position: relative;
}

// .backBtn.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
//     background-color: $primary-color-2;
// }

.usecase {
  border-radius: $box-border-radius;
  cursor: pointer;
  padding: 2.5vw 2.5vw;
  /*    !*margin: 20px;*!*/
  /*    //border-radius: $box-border-radius;*/
  /*    border-radius: 25px;*/
  /*    //@include material-shadow(1);*/
  height: 100%;
  position: relative;
  padding-bottom: 150px;
  /*    background-color: white;*/

  /*    &.highlight {*/
  /*        color: white;*/

  /*        .nice-title {*/
  /*            color: white;*/
  /*        }*/
  /*    }*/
  background-color: $bg2;

  &:hover {
    //@include material-shadow(2);
    background-color: $bg2;
  }

  /*    &.fade {*/
  /*        filter: grayscale(100%);*/
  /*        opacity: 0.7;*/
  /*    }*/

  .choose {
    position: absolute;
    bottom: 30px;
    left: 0;
    width: 100%;
    text-align: center;
  }
}

.theader {
  /*border-collapse: collapse;*/
  td {
    padding-bottom: 10px;
    font-size: 1.2em;
    //font-weight: 700;
    border-bottom: 1px solid #666;
  }
}

/*.device-md {*/
/*    .absBack {*/
/*        position: sticky*/
/*    }*/
/*}*/

.vdevice-not-xs {
  .counterStuff .row {
    flex-wrap: nowrap;
  }
}

.vdevice-xs {
  .plusImg {
    margin-right: 0;
  }

  .anzahl {
    text-align: right;
  }
}

</style>
